import React, {useEffect} from 'react';
import useRedux from 'infrastructure/js/hooks/useRedux';
import useLabels from 'infrastructure/js/hooks/useLabels';
import Header, {headerItemsLabels} from '../../../Common/Header/header';
import {MatSettingsMenuItemsIds} from '../../../../enums/navigationMenuItemsIds';
import {gridsNames} from '../../../../enums/gridsNames.js';
import QplsViewGrid from './QplsViewGrid/qplsViewGrid';
import {List} from 'immutable';
import {jsxActions as headerSettingsActions} from '../../../../actions/Header/headerSettingsActions';
import {jsxActions as qplsViewActions } from '../../../../actions/Administration/MatSettingsPage/qplsViewActions';
import {jsxActions as qplsViewGridActions} from '../../../../actions/Administration/MatSettingsPage/qplsViewGridActions';
import {jsxActions as fetchEntitiesActions} from '../../../../actions/FetchEntities/fetchEntitiesActions';
import { jsxActions as matSettingsPageActions } from '../../../../actions/Administration/MatSettingsPage/matSettingsPageActions.js';
import { jsxActions as updateMaterialQplVersionDialogActions} from '../../../../actions/Administration/MatSettingsPage/Dialogs/updateMaterialQplVersionDialogActions.js';
import { jsxActions as importFilesJsonDialogActions} from '../../../../actions/Dialogs/ImportFilesJsonDialog/importFilesJsonDialogActions.js';
import QplFormWrapper from './QplForm/qplFormWrapper';
import { Route, Switch } from 'react-router-dom';
import QplTestFormWrapper from '../QplTestsView/QplTestForm/qplTestFormWrapper';
import {PL_DialogWrapper} from 'infrastructure/js/components/Dialog/dialog';
import UpdateMaterialQplVersionDialog from '../MaterialTypesView/Dialogs/UpdateMaterialQplVersionDialog/updateMaterialQplVersionDialog';
import PermissionManager from 'infrastructure/js/utils/permissionManager';
import {ImportAcceptFileTypes, ImportTypes} from '../../../../enums/importTypes';
import ImportFilesJsonDialog from '../../../Dialogs/ImportFilesJsonDialog/importFilesJsonDialog';
import {isLoggedInUser} from '../../../../utils/userHelper';



const getState = (state) => {
  let grid = state.grid?.get(gridsNames.ADMINISTRATION_MAT_SETTINGS_QPLS) || null;
  let updateMaterialQplVersionGrid = state.grid.get(gridsNames.ADMINISTRATION_MAT_SETTINGS_UPDATE_MATERIAL_QPL_VERSION) ? state.grid.get(gridsNames.ADMINISTRATION_MAT_SETTINGS_UPDATE_MATERIAL_QPL_VERSION) : null;

  return {
    sHasRows: grid?.get('rows')?.size > 0 || false,
    sSelectedRowsData: grid?.get('selectedRowsData') || List(),
    sUpdateMaterialQplVersionGrid: updateMaterialQplVersionGrid,
    sUpdateMaterialQplVersionDialogData: state.administration.getIn(['matSettingsPage', 'updateMaterialQplVersionDialog']),
    sImportFilesJsonDialogData: state.dialogs.get('importFilesJsonDialog'),
  };
};

const allActions = {
  headerSettingsActions,
  qplsViewActions,
  qplsViewGridActions,
  fetchEntitiesActions,
  matSettingsPageActions: matSettingsPageActions,
  updateMaterialQplVersionDialogActions: updateMaterialQplVersionDialogActions,
  importFilesJsonDialogActions: importFilesJsonDialogActions,
};

export default function QplsView(props) {

  const labels = useLabels('mat.administration.matsettings.qpls.view.');
  const { state, actions } = useRedux(allActions, getState);
  const {sHasRows = false, sSelectedRowsData, sUpdateMaterialQplVersionGrid,
    sUpdateMaterialQplVersionDialogData, sImportFilesJsonDialogData } = state;

  const isViewOnly = !PermissionManager.hasEditQplPermissions();

  useEffect(() => {
    actions.matSettingsPageActions.onSelectedMenuItemChanged(MatSettingsMenuItemsIds.NAV_ELEMENT_QPLS);
  }, []);


  const getHeaderItems = () => {

    return  {
      buttons: [
        {
          id: 'clearFilters',
          label: '',
          icon: 'pl pl-filter-clear',
          action: actions.qplsViewActions.clearFilters,
          tooltip: headerItemsLabels.CLEAR_FILTERS,
        },
        {
          id: 'refresh',
          label: '',
          icon: 'pl pl-refresh',
          action: actions.qplsViewActions.reload,
          tooltip: headerItemsLabels.REFRESH,
        },
        ...( PermissionManager.isQplEnabled() ? [
          {
            id:'create',
            label: headerItemsLabels.CREATE,
            icon: 'pl pl-icon-add',
            disabled: isViewOnly,
            action: () => {
              props.history.push(`${props.match.url}/qplForm`)
            },
          },
          {
            id:'edit',
            label: isViewOnly ? headerItemsLabels.VIEW : headerItemsLabels.EDIT,
            icon: isViewOnly ? '' : 'pl pl-edit-icon',
            className: isViewOnly ? 'no-icon' : '',
            disabled: !(sHasRows && sSelectedRowsData.size === 1),
            action: () => {
              props.history.push(`${props.match.url}/qplForm/${sSelectedRowsData.get(0)?.id}/edit`)
            },
          }] : []),
        ],
      kebab: {
        menuItems: [
          ...( PermissionManager.isQplEnabled() ? [
            {
              id:'activate',
              label: headerItemsLabels.ACTIVATE,
              action: actions.qplsViewActions.activateQpl,
              disabled: (sSelectedRowsData?.size !== 1 ||
                         sSelectedRowsData?.get(0)?.isActive ||
                         isViewOnly ||
                         !PermissionManager.hasActivateQPLsPermissions() || isLoggedInUser(sSelectedRowsData?.get(0)?.createdBy)
                        ),
              actionData:  sSelectedRowsData?.get(0)?.id,
            },
            {
              id:'updateVersion',
              label: headerItemsLabels.UPDATE_VERSION,
              action: () => {
                props.history.push(`${props.match.url}/qplForm/${sSelectedRowsData.get(0)?.id}/update`)
              },
              disabled: (sSelectedRowsData?.size !== 1) || isViewOnly,
            },
            {
              id:'clone',
              label: headerItemsLabels.CLONE,
              action: () => {
                props.history.push(`${props.match.url}/qplForm/${sSelectedRowsData.get(0)?.id}/clone`)
              },
              disabled: (!sSelectedRowsData || sSelectedRowsData.size !== 1 || isViewOnly),
            },
            {
              id:'exportQpl',
              label: headerItemsLabels.EXPORT,
              disabled: (!sSelectedRowsData || sSelectedRowsData.size !== 1 || !sSelectedRowsData?.get(0)?.isActive),
              action: actions.qplsViewActions.exportQpl,
              actionData:  sSelectedRowsData?.get(0)?.id,
            },
            {
              id:'remove',
              label: headerItemsLabels.DELETE,
              action: actions.qplsViewActions.removeQpl,
              disabled: (!sSelectedRowsData || sSelectedRowsData.size !== 1 || isViewOnly),
              actionData:  sSelectedRowsData?.get(0)?.id,
            }
            ] : []),
          ...( PermissionManager.isCoCEnabled() ? [
            {
              id:'importQpl',
              label: headerItemsLabels.IMPORT,
              action: actions.headerSettingsActions.onImportFilesJsonClick,
              // disabled: false,
              actionData: {
                importType: ImportTypes.IMPORT_QPL_JSON,
                acceptFileTypes: [ImportAcceptFileTypes.JSON],
                parentComponent: actions.reload
              }
            }] : []),
        ]
      }
    };
  }

  const reloadPage = () => {
    actions.qplsViewActions.reload();
  };

  return (

    <Switch>
      <Route key='qplFormKey' exact
             path={`${props.match.path}/qplForm/:qplId?/:mode?`}
             component={QplFormWrapper}
      >
      </Route>

      <Route key='qplTestFormKey' exact
             path={`${props.match.path}/:qplId/qplTestForm/:qplTestId?/:mode?`}
             render={(props) => <QplTestFormWrapper {...props} key={props.location.search} />}
      >
      </Route>

      <Route key='qplsViewKey' path={props.match.path}>
        <div className="administration-view">
          <div className="title">{labels.get('title')}</div>

          <Header {...getHeaderItems()}/>

          <QplsViewGrid actions={{...actions.qplsViewGridActions, ...actions.fetchEntitiesActions}} />

          <PL_DialogWrapper dialogComponent={UpdateMaterialQplVersionDialog}
                            show={sUpdateMaterialQplVersionDialogData.get('show')}
                            actions={actions.updateMaterialQplVersionDialogActions}
                            sData={sUpdateMaterialQplVersionDialogData}
                            sGrid={sUpdateMaterialQplVersionGrid}
                            reloadParentComponent={reloadPage}
          />
          <PL_DialogWrapper
            dialogComponent={ImportFilesJsonDialog}
            show={sImportFilesJsonDialogData.get('show')}
            actions={actions.importFilesJsonDialogActions}
            sData={sImportFilesJsonDialogData}
            reloadParentComponent={reloadPage}
            // sLoggedInUser={this.props.sLoggedInUser}
          />

        </div>
      </Route>
    </Switch>
  )
}
